<template>
  <o-modal
      v-model:active="isActive"
      :width="400"
      class="verify-human-modal"
      :teleport="true"
      :can-cancel="false"
  >
    <div class="title">Verify You Are Human</div>
    <div class="box">
      <o-checkbox v-model="verified">
        Verify you are human
      </o-checkbox>
    </div>

    <div class="help is-center">
      <div class="is-bold">Why am I seeing this?</div>
      <div >Aggressive spam filters can click links in email before delivering them. By verifying you are a human, we can confirm your response as legitimate.</div>
      <div class="has-margin-top-large"><img src="https://assets.p-suite.io/powered_by_preconSuiteLogo.svg" width="150"></div>
    </div>
  </o-modal>
</template>

<script setup lang="ts">

import {ref, watch} from "vue";

const isActive = ref<boolean>(true);
const verified = ref<boolean>(false);

const emit = defineEmits<{
  'verified': [],
}>();

watch(verified, () => {
  if (verified.value) {
    emit("verified");
    isActive.value = false;
  }
});

</script>

<style lang="scss" scoped>

.verify-human-modal {
  z-index: 99999;
}

</style>

<style lang="scss">

.verify-human-modal {

  .is-center {
    text-align: center;
  }

  .is-bold {
    font-weight: bold;
  }

  .modal-content {
    max-width: 400px;

    .box {
      overflow: auto;
      max-height: 80% !important;
    }
  }
}

@media (max-width: 768px) {

  .modal {
    .animation-content {
      max-width: 350px !important;
      margin-left: 1.5em !important;
    }
  }
}

</style>
